import { borderRadius, breakpoint, color, fontSize } from '@core-ds/primitives';

import styles from './styles';
import fonts from './foundations/fonts';
import shadow from './foundations/shadow';
import space from './foundations/space';
import Avatar from './components/Avatar';
import Badge from './components/Badge';
import Button from './components/Button';
import Input from './components/Input';
import Link from './components/Link';
import Modal from './components/Modal';
import Select from './components/Select';
import Tabs from './components/Tabs';
import Tooltip from './components/Tooltip';

export const theme = {
   styles,
   breakpoints: { ...breakpoint, base: '0px', '2xl': '1536px' },
   colors: { ...color },
   fonts,
   fontSizes: { ...fontSize },
   radii: { ...borderRadius, base: borderRadius.md, full: borderRadius.pill },
   shadows: shadow,
   space,
   components: {
      Avatar,
      Badge,
      Button,
      Input,
      Link,
      Modal,
      Select,
      Tabs,
      Tooltip,
   },
};
